// extracted by mini-css-extract-plugin
export default {"footerSlot":"FooterSlot-footerSlot-b91"};